__turbopack_context__.v({
  "answer": "QuickAnswers-module__oYG3dW__answer",
  "buttonContainer": "QuickAnswers-module__oYG3dW__buttonContainer",
  "content": "QuickAnswers-module__oYG3dW__content",
  "headingContainer": "QuickAnswers-module__oYG3dW__headingContainer",
  "highlightQuestion": "QuickAnswers-module__oYG3dW__highlightQuestion",
  "introHeading": "QuickAnswers-module__oYG3dW__introHeading",
  "mainContent": "QuickAnswers-module__oYG3dW__mainContent",
  "qAndAItem": "QuickAnswers-module__oYG3dW__qAndAItem",
  "questions": "QuickAnswers-module__oYG3dW__questions",
  "questionsAndAnswers": "QuickAnswers-module__oYG3dW__questionsAndAnswers",
  "toggleButtons": "QuickAnswers-module__oYG3dW__toggleButtons",
});
